module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Share to...","searchPlaceholder":"Search Contact","myContacts":"My Contacts","enterpriseContacts":"Enterprise Contacts","groups":"Groups","selectContacts":"Share"},"es":{"title":"Compartir a...","searchPlaceholder":"Buscar contacto","myContacts":"Mis Contactos","enterpriseContacts":"Contactos Empresariales","groups":"Groupos","selectContacts":"Compartir"}}')
  delete Component.options._Ctor
}
